module.exports = __webpack_public_path__ + "static/media/SCROLL-DOWN-button.4a8d4eb0.gif";